module.exports = __webpack_public_path__ + "Pixel_2_XL_icon.svg?a27ea0fa0f95c3ae15a4c7c84ed88223";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Pixel_2_XL_icon.svg
// module id = 208
// module chunks = 0